<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-6 col-12">
                <label for="date">Transfer Date</label>
                <wj-input-date id="date" [(ngModel)]="target.date" name="date"></wj-input-date>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="material">Tool/Consumable</label>
                    <wj-combo-box
                        id="material"
                        [(ngModel)]="target.material"
                        name="material"
                        [itemsSource]="materialList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="location">Location</label>
                    <wj-combo-box
                        id="location"
                        [(ngModel)]="target.location"
                        name="location"
                        [itemsSource]="locationList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="quantity">Quantity</label>
                    <input id="quantity" type="number" class="form-control" [(ngModel)]="target.quantity" name="quantity" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="requestedByHrRef">Requested By</label>
                    <wj-combo-box
                        id="requestedByHrRef"
                        [(ngModel)]="target.requestedByHrRef"
                        name="requestedByHrRef"
                        [itemsSource]="activeUserList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label for="user">User</label>
                    <wj-combo-box
                        id="user"
                        [(ngModel)]="target.userHrRef"
                        name="userHrRef"
                        [itemsSource]="activeUserList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
